import { BuyerJobList } from '@features/buyer/jobs/buyer-job-row';
import {
  defaultJobListFilter,
  type JobListFilter,
} from '@features/jobs';
import { useBuyerPastJobsQuery } from '@lib/api/jobs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import type { BuyerPastJob } from './pastJobTypes';

interface PastJobProps {
  search?: string;
  filter?: JobListFilter;
  filtering?: boolean;
}

const PastJob = ({
  search = '',
  filter = defaultJobListFilter,
  filtering = false,
}: PastJobProps): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    jobs,
    isPending,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useBuyerPastJobsQuery(search, filter);
  const searching = Boolean(search);
  const loading =
    isPending ||
    (isFetching && (searching || filtering) && !isFetchingNextPage);

  const emptyTitle = searching
    ? t('jobs.emptySearchTitle')
    : filtering
      ? t('jobs.emptyFilterTitle')
      : t('jobs.emptyPastTitle');
  const emptyHint = searching
    ? t('jobs.emptySearchHint', { query: search })
    : filtering
      ? t('jobs.emptyFilterHint')
      : t('jobs.emptyPastHint');

  return (
    <BuyerJobList
      jobs={jobs as BuyerPastJob[]}
      loading={loading}
      searching={searching || filtering}
      emptyTitle={emptyTitle}
      emptyHint={emptyHint}
      hasNextPage={Boolean(hasNextPage)}
      isFetchingNextPage={isFetchingNextPage}
      onLoadMore={() => {
        void fetchNextPage();
      }}
      onOpen={(job) => navigate('/rating-detail', { state: { jobData: job } })}
    />
  );
};

export default PastJob;
